(function ($, root, undefined) {
  $(function () {
    "use strict";

    // DOM ready, take it away
    gsap.registerPlugin("ScrollTrigger");
    gsap.registerPlugin("CSSPlugin");

    gsap.config({
      nullTargetWarn: false,
    });

    // parallax
    function createParallax() {
      gsap.to(".parallax-item", {
        scrollTrigger: {
          scrub: true,
          invalidateOnRefresh: true,
        },
        y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
        ease: "none",
      });
    }
    createParallax();

    // logo animation
    const logoAnimation = gsap.timeline({ paused: true });
    const logo = $("#logo");

    const logoTwo = $(logo).find(".two");
    const logoFrom = $(logo).find(".from");
    const logoLargeTwo = $(logo).find(".logo-two");

    const animationSpeed = 0.6;
    const animationSpeedBack = 0.3;
    let playing = false;

    // set flag
    logoAnimation.add(function () {
      playing = true;
    });

    // animate them away
    logoAnimation.to(logoTwo, {
      // delay:animationSpeed*2,
      duration: animationSpeed,
      x: "120px",
      ease: Power4.easeOut,
      opacity: 0,
    });
    logoAnimation.to(logoFrom, {
      duration: animationSpeed,
      delay: -animationSpeed,
      x: "-120px",
      ease: Power4.easeOut,
      opacity: 0,
    });

    // set a random order for both
    logoAnimation.add(function () {
      var randomValue = Math.round(Math.random());
      if (randomValue == 0) {
        logoFrom.detach().insertBefore(logoLargeTwo);
      } else {
        logoFrom.detach().insertAfter(logoLargeTwo);
      }
    });
    logoAnimation.add(function () {
      var randomValue = Math.round(Math.random());
      if (randomValue == 0) {
        logoTwo.detach().insertBefore(logoLargeTwo);
      } else {
        logoTwo.detach().insertAfter(logoLargeTwo);
      }
    });

    // animate them back
    logoAnimation.to(logoTwo, {
      duration: animationSpeedBack,
      x: "0",
      ease: Power4.easeOut,
      opacity: 1,
    });
    logoAnimation.to(logoFrom, {
      duration: animationSpeedBack,
      delay: -animationSpeedBack,
      x: "0",
      ease: Power4.easeOut,
      opacity: 1,
    });

    // reset the flag and timeline back to start
    logoAnimation.add(function () {
      playing = false;
    });

    // play the animation
    setTimeout(function () {
      logoAnimation.play();
    }, 2000);

    // on logo hover play again
    logo.on("mouseenter", function () {
      if (playing == false) {
        logoAnimation.restart();
        logoAnimation.play();
      }
    });

    // menu constants
    const openMenu = gsap.timeline({ paused: true });
    const openMenuButton = $("#open-menu");

    // open menu timeline animations
    openMenu.from("#nav", {
      duration: 0.6,
      ease: Power4.easeOut,
      y: "-100%",
    });
    openMenu.to("#nav", {
      duration: 0.6,
      delay: -0.6,
      ease: Power4.easeOut,
      autoAlpha: 1,
    });

    // open menu timeline animations
    openMenu.from("#nav li", {
      delay: -0.4,
      duration: 0.4,
      stagger: 0.02,
      ease: Power4.easeOut,
      y: "-50%",
      autoAlpha: 0,
    });

    // open menu timeline animations
    openMenu.to(".contact-details", {
      delay: -0.4,
      duration: 0.6,
      ease: Power4.easeOut,
      autoAlpha: 1,
    });

    // open menu
    function openMenuActions() {
      openMenu.play().timeScale(1);

      // check if url is .com
      if (window.location.href.indexOf(".com") > -1) {
        openMenuButton.html("back");
      } else {
        openMenuButton.html("terug");
      }

      $(".wrapper").addClass("blurred");
      $("html").addClass("no-scroll");
    }

    // close menu
    function closeMenuActions() {
      openMenu.reverse().timeScale(-2);
      openMenuButton.removeClass("active").html("menu");
      $(".wrapper").removeClass("blurred");
      $("html").removeClass("no-scroll");
    }

    // open menu event handler
    openMenuButton.on("click", function () {
      // toggle classes
      $(this).toggleClass("active");

      if ($(this).hasClass("active")) {
        openMenuActions();
      } else {
        closeMenuActions();
      }
    });

    // add class to inout container
    function makeInputContainerWhite(field) {
      let parentDiv = $(field).closest(".ginput_container");
      if ($(field).val() !== "") {
        $(parentDiv).addClass("active");
      } else {
        $(parentDiv).removeClass("active");
      }
    }

    // on changes -> add class to ginput_container
    $(":input").on("keyup change", function () {
      let field = $(this);
      makeInputContainerWhite(field);
    });
    $("select").change(function () {
      let parentDiv = $(this).closest(".ginput_container_select");
      if ($(this).val() !== "") {
        $(parentDiv).addClass("active");
      } else {
        $(parentDiv).removeClass("active");
      }
    });

    // performances filter
    // $('#performances-filter .ginput_container_select .close').click(function() {
    // 	let parentDiv = $(this).closest('.ginput_container_select');
    // 	let selectField = $(parentDiv).find('select');
    //
    // 	$(selectField).prop('selectedIndex',0); // back to default
    // 	$(selectField).find('option:selected').removeAttr('selected'); // remove selected option
    //
    // 	$(parentDiv).removeClass('active'); // remove active class from container
    // 	$('#performances-filter').trigger('change'); // trigger ajax call and update results
    // });

    // sliders
    $("#slider").flickity({
      cellAlign: "left",
      contain: false,
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      autoPlay: 4000,
    });

    // Masonry grid
    function packeryGrid() {
      let $grid = $(".grid");
      $grid.imagesLoaded().progress(function () {
        $grid.packery();
      });
      $(window).trigger("resize");
    }
    if ($(".grid").length) {
      packeryGrid();
    }

    // press photo modal
    const modal = $("#modal");
    const modalContent = $("#modal-content");

    let pressFotos = $(".pressfotos figure");

    // close modal function
    function modal_close() {
      $("body").find(modal).fadeOut();
      $("html").removeClass("noscroll");
    }

    // close modal
    modal.click(function () {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(modalContent).length) {
        modal_close();
      }
    });

    // create modal content
    function create_modal_content(figure) {
      let largeImage = $(figure).data("imageLarge");
      let originalImage = $(figure).data("imageOriginal");
      let title = $(figure).data("imageTitle");

      let totalImages = pressFotos.length;
      let imageNumber = $(figure).data("imageNumber");
      let prevImage = "";
      let nextImage = "";

      if (imageNumber == 1) {
        prevImage = totalImages;
      } else {
        prevImage = imageNumber - 1;
      }

      if (imageNumber == totalImages) {
        nextImage = 1;
      } else {
        nextImage = imageNumber + 1;
      }

      let html = "";
      let image = '<img src="' + largeImage + '">';
      let modalTitle =
        '<div class="title">' + title + ' <a download="' + title + '" href="' + originalImage + '" title="' + title + '">download</div>';
      let prev = '<div data-goto-image="' + prevImage + '" class="arrow prev"></div>';
      let next = '<div data-goto-image="' + nextImage + '" class="arrow next"></div>';

      html += image;
      html += modalTitle;
      html += prev;
      html += next;

      modalContent.html(html);
      modalContent.find("img").hide().fadeIn();
    }

    // open modal and add image content
    pressFotos.click(function () {
      let figure = $(this);
      modalContent.html();

      create_modal_content(figure);
      modal.fadeIn().css("display", "flex");
    });

    // prev/next modal
    $(document).on("click", ".arrow", function () {
      let imageId = $(this).data("gotoImage");
      let figure = $("#image-" + imageId);

      create_modal_content(figure);
    });

    // datepicker
    // $("#datepicker").datepicker({
    //     dateFormat: "dd-mm-yy"
    // });

    // scroll to playlist on landingspage
    $(".scroll-to-playlist").click(function () {
      $("html, body").animate(
        {
          scrollTop: $(".playlist-block").offset().top - 48,
        },
        1000
      );
    });

    const socialMediaKit = $("#modal-social-media-kit");
    const socialMediaKitContent = $("#social-media-kit-content");
    const socialMediaKitClose = $("#modal-social-media-kit-close");

    $("#open-social-media-kit").click(function () {
      socialMediaKit.fadeIn();
    });

    socialMediaKitClose.click(function () {
      socialMediaKit.fadeOut();
    });
  });
})(jQuery, this);
